import { Routes } from '@angular/router';
export const ADMIN_ROUTES: Routes = [];
